import { render, staticRenderFns } from "./ViewStandardisedJob.vue?vue&type=template&id=822f4f38&scoped=true"
import script from "./ViewStandardisedJob.vue?vue&type=script&lang=ts"
export * from "./ViewStandardisedJob.vue?vue&type=script&lang=ts"
import style0 from "./ViewStandardisedJob.vue?vue&type=style&index=0&id=822f4f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822f4f38",
  null
  
)

export default component.exports